/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import Image from 'next/image';
import Link from 'next/link';
import { useLanguage } from '@/providers/LanguageProvider';
import { OctagonAlertIcon } from 'lucide-react';
import { ErrorType } from 'types/error';

export const ErrorComponent = ({ status, statusText }: ErrorType) => {
  const { messages } = useLanguage();
  const langData = messages?.Error;
  return (
    <div className="flex h-[90vh] flex-col items-center justify-center gap-y-4">
      {/* logo */}
      <Link href={'/'}>
        <Image
          src="/logos/full-color-reversed/medium.svg"
          width={100}
          height={100}
          alt="Logo"
        />
      </Link>
      {/* error message */}
      <div className="flex max-w-xl gap-x-3 rounded-lg border border-[#F26C7452] bg-[#F26C7414] p-6 text-notification-error-dark">
        <OctagonAlertIcon size={32} />
        <div className="space-y-1">
          <h3 className="text-h3 font-medium">{langData?.error_message}</h3>
          {status && statusText ? (
            <p className="leading-[21.28px text-[14px] font-normal">
              {langData?.error}{' '}
              <span className="first-letter:capitalize">
                {status} - {statusText}
              </span>
            </p>
          ) : (
            <p className="leading-[21.28px text-[14px] font-normal">
              {langData?.check_console_for_details}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
